import React from 'react';
import { useNavigate } from 'react-router-dom';
import icon from '../Header/icon.png';
import {Rights, TextWrapper,BottomLogo,BottomWrapper, ExplanTextWrapper, } from './FooterStyle';

export const Footer = ({styleType, logoPicture}) => {
    const navigate = useNavigate();
    return (
        <BottomWrapper styleType={styleType} id={'footer'}>
            <BottomLogo styleType={styleType}><img className='lazyload' data-src={ icon } alt=''></img></BottomLogo>
            <TextWrapper styleType={styleType}>
                {['主頁', '公司主頁', '隱私條款'].map((e, index) => {
                    return(<div key={index} onClick={() => {
                        if(e === '主頁') {
                           navigate('/'); 
                        } else if (e === '公司主頁') {
                            window.location.href = 'https://yok-travel.com/COMPANY'
                        } else if(e === '隱私條款') {
                           navigate('/privacy'); 
                        } else if(e === '使用规则') {
                           navigate('/rules'); 
                        }
                    }}>{e}</div>);   
                })}
            </TextWrapper>
            <ExplanTextWrapper styleType={styleType}>※本サイトは、「R2事業再構築」採択事業の一環として構築されています。</ExplanTextWrapper>
            <Rights styleType={styleType}>
                {`©︎${new Date().getFullYear()} YOK INC.`}
            </Rights>
        </BottomWrapper>
    );
}